import Axios from 'axios';                              // 引入axios数据请求模块
import qs from 'qs';                                    // 引入qs格式转换模块
import router from '@/router/index';                     // 引入项目路由文件
import store from '@/vuex/store';                       // 引入Vuex状态管理

// 错误处理
const error_handle = (error) => {
    // if (error.response.status === 401) {
    // }
    // 通过返回的状态码对错误进行处理
}

// Axios全局配置
Axios.defaults.timeout = 30000;                         // 请求的过期时间30秒

if (process.env.NODE_ENV == 'development') {
    // 开发模式
    // Axios.defaults.baseURL = 'http://61.130.182.202/hjyy';//广东专用
} else {                                                
    // 生产模式
    Axios.defaults.baseURL = window.dynUrl.url + '/hjyy';
}
// http request 请求拦截器
Axios.interceptors.request.use(config => {
    // 设置请求头
    //config.withCredentials = true // 允许在请求头中携带token ,这个是解决跨域产生的相关问题
    // config.headers['access-token']: '' // 设置请求头中的access-token
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    config.headers['Accept'] = 'application/json;';
    config.headers['systemType'] = 3;
    let token = window.sessionStorage.getItem("token")
    if (token) {
        token = token.replace("\"","").replace("\"","");
        config.headers['token'] = token;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

// http response 响应拦截器
Axios.interceptors.response.use(response => {
    if (response) {
        if(sessionStorage.getItem('dateTime')==null|undefined|''){
            const asd = Date.parse(response.headers.date)
            var date = new Date(asd);
            var year = date.getFullYear() + '-';
            var month = (date.getMonth()+1 < 10 ? '0' + (date.getMonth()+1) : date.getMonth()+1) + '-';
            var dates = date.getDate() < 10 ? '0' + (date.getDate()): date.getDate();
            sessionStorage.setItem('dateTime',year + month + dates)
        }
    }
    return response;
}, error => {
    error_handle(error);
    return Promise.reject(error);
});

// 封装axios方法
export function fetch(method, url, params) {
    if (method == 'GET' || method == 'get') {
        return new Promise((resolve, reject) => {               // get请求方式，data为json类型，会自动拼接到请求地址后面
            Axios.get(url, {
                params: params
            }).then(response => {
                if (typeof response != 'undefined') {
                    let res = {
                        status: response.status,
                        data: response.data
                    }
                    resolve(res);
                }
            }).catch(error => {
                reject(error);
            });
        });
    } else if (method == 'POST' || method == 'post') {
        return new Promise((resolve, reject) => {               // post请求方式，需要将data转换成json字符串
            Axios.post(url, params).then(response => {
                if (typeof response != 'undefined') {
                    let res = {
                        status: response.status,
                        response: response.data
                    }
                    resolve(res);
                }
            }, error => {
                reject(error);
            });
        });
    } else if (method == 'PUT' || method == 'put') {
        return new Promise((resolve, reject) => {               // put请求方式，需要将data转换成json字符串
            Axios.put(url, qs.stringify(params)).then(response => {
                if (typeof response != 'undefined') {
                    let res = {
                        status: response.status,
                        response: response.data
                    }
                    resolve(res);
                }
            }, error => {
                reject(error);
            });
        });
    } else if (method == 'DEL' || method == 'del') {
        return new Promise((resolve, reject) => {               // delete请求方式，需要将data转换成json字符串
            Axios.delete(url, { data: qs.stringify(params) }).then(response => {
                if (typeof response != 'undefined') {
                    let res = {
                        status: response.status,
                        response: response.data
                    }
                    resolve(res);
                }
            }, error => {
                reject(error);
            });
        });
    }else if (method == 'PATCH' || method == 'patch') {
        return new Promise((resolve, reject) => {               // Patch请求方式，需要将data转换成json字符串
            Axios.patch(url, qs.stringify(params)).then(response => {
                if (typeof response != 'undefined') {
                    let res = {
                        status: response.status,
                        response: response.data
                    }
                    resolve(res);
                }
            }, error => {
                reject(error);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/axios/http/http.js